import { Skeleton } from "../../../../components/ui/common/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "../../../../components/ui/common/table";
import {
  COLUMN_COUNT,
  FACILITY_TABLE_COLUMN_CLASS,
  FACILITY_TABLE_COLUMNS,
  ROW_SKELETON_COUNT
} from "../constants/facilityList.constants";
import { FacilityTableProps } from "../types/facilityList.types";
import { FacilityTableRow } from "./FacilityTableRow";

/** Table shell: header row, skeleton rows while loading, empty state, facility rows. */
export const FacilityTable = ({
  rows,
  isLoading,
  countriesData,
  onView,
  onEdit,
  onDelete
}: FacilityTableProps) => (
  <div className="tw-relative tw-overflow-x-auto tw-rounded-lg tw-border tw-border-border tw-bg-white">
    <Table className="tw-w-full tw-table-fixed [&_td]:tw-px-4 [&_td]:tw-py-3 [&_th]:tw-px-4 [&_th]:tw-py-3">
      <TableHeader>
        <TableRow className="tw-border-b-0 tw-bg-primary/5 hover:tw-bg-primary/5 [&_th]:tw-bg-primary/5 [&_th]:tw-text-primary [&_th]:tw-font-semibold [&_th]:tw-align-middle">
          {FACILITY_TABLE_COLUMNS.map(column => (
            <TableHead key={column.key} className={FACILITY_TABLE_COLUMN_CLASS[column.key]}>
              {column.label}
            </TableHead>
          ))}
          <TableHead className={`${FACILITY_TABLE_COLUMN_CLASS.actions} tw-text-right`}>
            Actions
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          [...Array(ROW_SKELETON_COUNT)].map((_, index) => (
            <TableRow key={index} className="tw-bg-white">
              {[...Array(COLUMN_COUNT)].map((__, cellIndex) => (
                <TableCell key={cellIndex}>
                  <Skeleton className="tw-h-4 tw-w-full" />
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : rows.length === 0 ? (
          <TableRow className="tw-bg-white hover:tw-bg-white">
            <TableCell
              colSpan={COLUMN_COUNT}
              className="tw-py-12 tw-text-center tw-text-muted-foreground"
            >
              No facilities found.
            </TableCell>
          </TableRow>
        ) : (
          rows.map(row => (
            <FacilityTableRow
              key={row?._id}
              row={row}
              countriesData={countriesData}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))
        )}
      </TableBody>
    </Table>
  </div>
);
